<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <providers-info v-if="$router.currentRoute.params.cms === 'old'"></providers-info>
    <material-card
    :color="$vuetify.theme.themes.light.secondary"
      icon="folder_shared"
      :title="$t('Providers Services')"
    >
      <pbas-data-table
        ref="servicetable"
        :dataProvider="serviceProvider"
        :rowActions="serviceRowActions"
        :floatActions="serviceFloatActions"
        :selectActions="serviceSelectActions"
        :exporters="$exporters"
        @error="error = $event"
      ></pbas-data-table>
    </material-card>
    <material-card
    :color="$vuetify.theme.themes.light.secondary"
      icon="folder_shared"
      :title="$t('Providers')"
    >
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        :selectActions="selectActions"
        :exporters="$exporters"
        @error="error = $event"
      ></pbas-data-table>
    </material-card>
    <service-edit
      :service="editservice"
      @cancel="editservice = null"
      @update:service="
        editservice = null;
        $refs.servicetable.getDataAsync();
      "
    ></service-edit>
    <provider-edit
      :provider="editprovider"
      @cancel="editprovider = null"
      @update:provider="
        editprovider = null;
        $refs.table.getDataAsync();
      "
      :cms="$router.currentRoute.params.cms"
    ></provider-edit>
    <v-dialog v-model="showAssignments" scrollable max-width="700">
      <service-coverage-assignments
        :showCancel="true"
        @cancel="showAssignments = false"
        @saved="
          showAssignments = false;
          $refs.servicetable.getDataAsync();
        "
        :service="service"
      ></service-coverage-assignments>
    </v-dialog>
    <error-handler :error="error" />
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import Headers from "../../headers/Providers";
import HeadersNew from "../../headers/ProvidersNew";
import ServiceHeaders from "../../headers/ProviderService";
import { ODataProvider } from "pbas-vue-components";
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../../components/ErrorHandler";
import ServiceEdit from "./ServiceEdit.vue";
import ProviderEdit from "./ProviderEdit.vue";
import ProvidersInfo from "./ProvidersInfo.vue";
import ServiceCoverageAssignments from "./ServiceCoverageAssignments";
import { ODataHeader, ODataString } from "pbas-vue-components";
import { translate2 } from "../../trans2";
import { planSetter } from "../../mixins/planSetter";

export default {
  components: {
    ErrorHandler,
    ServiceEdit,
    ProviderEdit,
    ProvidersInfo,
    ServiceCoverageAssignments,
  },
  mixins: [planSetter],
  data: function() {
    return {
      service: null,
      editservice: null,
      editprovider: null,
      provider: undefined,
      serviceProvider: undefined,
      headers: Headers,
      serviceHeaders: ServiceHeaders,
      error: null,
      showAssignments: false,
      showImport: false,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.edit(item),
        },
        {
          name: "remove",
          icon: "delete",
          title: "globals.remove",
          handler: (item) => this.remove(item),
        },
      ],
      serviceRowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.editService(item),
        },
        {
          name: "assignCoverage",
          icon: "assignment_turned_in",
          title: "globals.assign",
          handler: (item) => {
            this.assignCoverage(item);
          },
        },
        {
          name: "remove",
          icon: "delete",
          title: "globals.remove",
          handler: (item) => this.removeService(item),
        },
      ],
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.edit({ PlanId: this.selectedPlan.Id });
          },
        },
      ],
      serviceFloatActions: [
        {
          name: "addItem",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.editService({ PlanId: this.selectedPlan.Id });
          },
        },
      ],
      selectActions: [
        {
          name: "delete",
          icon: "delete",
          title: "globals.remove",
          handler: (items) => {
            items.forEach((i) => this.remove(i));
          },
        },
      ],
      serviceSelectActions: [
        {
          name: "delete",
          icon: "delete",
          title: "globals.remove",
          handler: (items) => {
            items.forEach((i) => this.removeService(i));
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
    url() {
      if (this.$router.currentRoute.params.cms === "old") {
        return (
          this.settings.APIURL +
          "cms/odata/plans/" +
          this.selectedPlan.Id +
          "/Providers"
        );
      } else {
        return (
          this.settings.APIURL +
          "cms/plans/" +
          this.selectedPlan.Id +
          "/Providers"
        );
      }
    },
    servicesUrl() {
      if (this.$router.currentRoute.params.cms === "old") {
        return (
          this.settings.APIURL +
          "cms/odata/plans/" +
          this.selectedPlan.Id +
          "/ProviderServices"
        );
      } else {
        return (
          this.settings.APIURL +
          "cms/plans/" +
          this.selectedPlan.Id +
          "/ProviderServices"
        );
      }
    },
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("downloadCenter", [
      "deleteProviderService",
      "deleteProvider",
      "setBaseUrl",
      "setBaseOdataUrl",
    ]),
    ...mapActions("plansMembers", ["getCoverageIdentities"]),
    async loadPlanData() {
      if (this.$router.currentRoute.params.cms === "old") {
        this.setBaseOdataUrl("cms/odata/");
        this.setBaseUrl("cms/");
        this.headers = Headers;
      } else {
        this.setBaseOdataUrl("cms/plans/" + this.selectedPlan.Id + "/");
        this.setBaseUrl("cms/plans/" + this.selectedPlan.Id + "/");
        this.headers = HeadersNew;
      }
      this.provider = new ODataProvider(
        this.$axiosHttp,
        this.url,
        this.headers
      );
      let allCoverage = (await this.getCoverageIdentities({
        plan: this.selectedPlan.Id,
      })).value;
      this.serviceProvider = new ODataProvider(
        this.$axiosHttp,
       this.servicesUrl,
        this.serviceHeaders.concat([
          new ODataHeader({
            title: "globals.coverage",
            type: new ODataString("JsonCoverageIds", {
              getString: (item) => {
                // console.log(item);
                let cov = JSON.parse(item.JsonCoverageIds);
                // console.log(cov)
                let itemCov = allCoverage.filter((o) => {
                  // console.log(cov, o);
                  return cov && cov.filter((c) => c === o.Id).length > 0;
                });
                // console.log(itemCov)
                return itemCov
                  .map((o) => translate2(o.Current, "Name"))
                  .join(", ");
              },
            }),
            visible: true,
            allowVisibilityChange: true,
            searchable: true,
            sortable: false,
          }),
        ])
      );
    },
    edit(item) {
      this.editprovider = item;
    },
    editService(item) {
      this.editservice = item;
    },
    async remove(item) {
      try {
        await this.deleteProvider(item);
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
    },
    async removeService(item) {
      try {
        await this.deleteProviderService(item);
        this.$refs.servicetable.getDataAsync();
      } catch (error) {
        this.error = error;
      }
    },
    assignCoverage(item) {
      this.service = item;
      this.showAssignments = true;
    },
  },
};
</script>
